import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DigitalIdentityDashboardService } from 'src/app/features/digital-identity/authoring-tools/dashboard/dashboard.service';
import { DigitalIdentityReportService } from 'src/app/features/digital-identity/reports/reports.service';

@Injectable({ providedIn: 'root' })
export class DigitalIdentityDashboardDataResolver implements Resolve<any> {
  constructor(
    private dashboardService: DigitalIdentityDashboardService,
    private reportService: DigitalIdentityReportService
  ) {}

  resolve(): Observable<any> {
    const filter = 'all_time';

    return forkJoin({
      dashBoardData: this.dashboardService.getDiDashboardCardsData(),
      data: this.reportService.getDiReports(filter),
      chartdata: this.reportService.getDiChartData(filter)
    }).pipe(map(response => response));
  }
}
